export default __webpack_public_path__ + "static/path_cms-c256e89e6ec7edf4a9e2fb86d1da325e.webp";